import { useContext } from "react";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";
import { convertToJalali, formatGregorianDate } from "../../../../utils/date";
import { numberWithCommas } from "../../../../utils/utility";
import { useNavigate } from "react-router";

//import general components
import { BaseButton } from "../../../common/base-button/base-button";

//import URL
import { getFlightAutomaticReservationPageUrl } from "../../../../routing/routingConstants/AppUrls";

function DetailsContent({ type, title, list }) {
    return (
        <Grid container item xs={12}>
            <h3>{title}</h3>
            <Grid container className="smart-reservation__box" flexDirection="column" gap={1} p={2}>
                {type === "autoBooking" ? "مسافر" : ""}
                {list.map(item => {
                    return (
                        <Typography key={item.id} variant="span" fontSize={{ xs: "0.875rem", md: "1rem" }} display="flex" gap={2}>
                            {item.label}:<span className="smart-reservation__text">{item.value}</span>
                        </Typography>
                    );
                })}
            </Grid>
        </Grid>
    );
}

export default function SmartReservationDetails({ item, type }) {
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);
    const navigate = useNavigate();

    const passengers = item?.passengers;

    const generalInformation = JSON.parse(sessionStorage.getItem("generalInformation")) || {};

    const GENDER_OPTION = {
        MALE: t("male"),
        FEMALE: t("female"),
    };

    const handleEdit = () => {
        sessionStorage.setItem(
            "generalInformation",
            JSON.stringify({
                ...generalInformation,
                isFlightInternational: item?.departure_city?.country?.id === 1 || item?.destination_city?.country?.id === 1 ? false : true,
                isAutomaticReserve: true,
            }),
        );

        sessionStorage.setItem(
            "selectedReservation",
            JSON.stringify({
                item,
            }),
        );

        item?.departure_city?.country?.id !== 1
            ? sessionStorage.setItem(
                  "intFlightPassengers",
                  JSON.stringify({
                      passengers,
                  }),
              )
            : sessionStorage.setItem(
                  "flightPassengers",
                  JSON.stringify({
                      passengers,
                  }),
              );

        navigate(getFlightAutomaticReservationPageUrl(locale));
    };

    return (
        <Grid container item xs={12} gap={2} flexDirection="column" alignItems="flex-end">
            <DetailsContent
                type={type}
                title={t("Flight.selectedTicket")}
                list={[
                    {
                        id: 1,
                        label: t("Flight.flightDate"),
                        value:
                            locale === "fa" ? convertToJalali(item?.departure_date) : formatGregorianDate(item?.departure_date, null, "YYYY/MM/DD"),
                    },
                    {
                        id: 2,
                        label: t("flightTime"),
                        value: item?.departure_time_ranges.map(time => time?.title).join("، "),
                    },
                    {
                        id: 3,
                        label: t("airline"),
                        value: item?.all_airlines ? t("Flight.allAirlines") : item?.airlines.map(airline => airline?.name).join("، "),
                    },
                    {
                        id: 4,
                        label: t("aircraft"),
                        value: item?.cabin_type.value,
                    },
                ]}
            />

            {type === "autoBooking" && (
                <Grid container item xs={12}>
                    <h3>{t("passengers")}</h3>
                    {item?.passengers?.map(passenger => {
                        return (
                            <DetailsContent
                                key={passenger.id}
                                // title={t("passengers")}
                                type={type}
                                list={[
                                    {
                                        id: 1,
                                        label: t("fullName"),
                                        value:
                                            locale === "fa"
                                                ? passenger?.first_name + " " + passenger?.last_name
                                                : passenger?.english_first_name + " " + passenger?.english_last_name,
                                    },
                                    {
                                        id: 2,
                                        label: t("gender"),
                                        value: GENDER_OPTION[passenger?.gender],
                                    },
                                    {
                                        id: 3,
                                        label: t("nationalCode"),
                                        value: passenger?.national_code,
                                    },
                                    {
                                        id: 4,
                                        label: t("birthday"),
                                        value:
                                            locale === "fa"
                                                ? convertToJalali(passenger?.birthdate)
                                                : formatGregorianDate(passenger?.birthdate, null, "YYYY/MM/DD"),
                                    },
                                ]}
                            />
                        );
                    })}
                </Grid>
            )}

            <DetailsContent
                type={type}
                title={t("price")}
                list={[
                    {
                        id: 1,
                        label: t("General.upTo"),
                        value: numberWithCommas(item?.max_price) + " " + t("currency"),
                    },
                ]}
            />

            {type === "autoBooking" && (
                <Grid container item md={4} justifyContent="flex-end">
                    <BaseButton text={t("edit")} color="outline" size="medium" radius="radius-10" handleClick={handleEdit} disabled={item?.disabled}/>
                </Grid>
            )}
        </Grid>
    );
}
